import FormDataFormatter from "../FormDataFormatter";

class PortalContactSerializer {
    static serialize(formFields, update = false) {

        let request = {
            name: formFields.name,
            email: formFields.email,
            phone: formFields.phone,
            departmentId: formFields.departmentId,
            sorter: formFields.sorter,
            portalId: formFields.portalId
        };

        if (formFields.images && formFields.images.length !== 0) {
            request.photo = formFields.images[0];
        }
        if (update && formFields.defaultImageIds.length !== 0) {
            request.defaultImageIds = formFields.defaultImageIds;
        }

        return FormDataFormatter.getFormData({...request});
    }

    static unserialize(response) {
        let formData = {...response};
        if(formData.department) {
            formData.departmentId = formData.department.id;
            formData.departmentName = formData.department.name;
        }

        if(formData.portal) {
            formData.portalId = formData.portal.id || null;
            formData.portalName = formData.portal.name || null;
        }
        formData.defaultImageIds = [];
        // formData.images = null;
        formData.defaultImages = Array.from(formData.photo);
        if (formData.defaultImages.length !== 0) {
            formData.defaultImageIds.push(formData.defaultImages[0].id);
        } else {
            formData.defaultImageIds = [];
        }

        return formData;
    }
}

export default PortalContactSerializer;


// WEBPACK FOOTER //
// ./web/src/services/portal-contact/PortalContactSerializer.js